import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import Heading from '@components/Heading';
import Section from '@components/Section';
import { CONNECTIONS } from '@data/connections';
import { loaderProp } from '@utils/random';

const SupportedConnectionsSection = () => {
  const data = {
    heading: 'Supported connections',
    connections: CONNECTIONS,
  };
  return (
    <Section>
      <Heading
        Tag="h2"
        size="lg"
        className={`sm:max-w-xl mt-10 md:mt-20 lg:mt-24 text-center`}
      >
        {data.heading}
      </Heading>

      <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 mt-10 md:mt-20">
        {data.connections.map((connection, index) => (
          <Link key={index} href={connection.href} as={connection.asPath}>
            <a>
              <li className="border border-[#CFD5DB] group rounded-[24px] text-center flex items-center flex-col gap-6 pt-6 pb-4 px-4">
                <figure
                  title={connection.title}
                  className="h-8 w-8 group-hover:opacity-70 sm:h-12 sm:w-12 flex relative items-center justify-center shrink-0"
                >
                  <Image
                    alt={`${connection.title} connection illustration`}
                    src={connection.src}
                    layout="fill"
                    loader={loaderProp}
                  />
                </figure>

                <p className="mx-auto text-xs group-hover:bg-gray-50 border border-[#CFD5DB] rounded-[200px] min-w-[88px] w-full inline-block px-4 py-2 font-semibold font-inter text-black">
                  {connection.title}
                </p>
              </li>
            </a>
          </Link>
        ))}
      </ul>
    </Section>
  );
};

export default SupportedConnectionsSection;
